export const BASE_URL = process.env.NEXT_PUBLIC_BASE_URL;
export const BASE_KEY = process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS;
export const BASE_URL_CT = process.env.NEXT_PUBLIC_BASE_URL_YK;
export const BASE_URL_DT = process.env.NEXT_PUBLIC_BASE_URL_DT;
export const BASE_FILE_URL = process.env.NEXT_PUBLIC_BASE_FILE_URL;
export const BASE_SITE_KEY = process.env.NEXT_PUBLIC_BASE_SITE_KEY;
export const BASE_URL_ARTICLE = process.env.NEXT_PUBLIC_BASE_URL_ARTICLE;
export const URL = process.env.NEXT_PUBLIC_URL;
export const USE_SOCKETVIEW = process.env.NEXT_PUBLIC_USE_SOCKETVIEW;

export const emptyData = {
  results: [],
  page: 1,
  totalPages: 0,
  limit: 10,
  totalResults: 0,
};

export const LANG_DEFAULT_VI = {
  home: {
    news: 'Tin tức',
    hometitle: 'Trang chủ',
    highlightNews: 'SỰ KIỆN NỔI BẬT',
    selectLink: 'Liên kết trang web',
    searchArticle: 'Tìm kiếm bài viết',
    searchPlahoder: 'Tìm kiếm ',
    selectLanguage: 'Chọn ngôn ngữ',
    keywords: 'Từ khóa',
    newDocument: 'VĂN BẢN MỚI',
    promulgate: 'Ban hành',
    accessStatitics: 'THỐNG KÊ TRUY CẬP',
    accessing: 'Đang truy cập',
    today: 'Hôm nay',
    totalVisits: 'Tổng lượt truy cập',
    find: 'Tìm',
    viewByDay: 'Xem tin theo ngày',
    checkTable: 'Không có bản ghi nào',
    erorrNotFound: 'Không tìm thấy trang',
    back: 'Quay lại',
    avartarAlt: 'Ảnh mặc định',
    viewDetail: 'Xem chi tiết',
    searchForGoogle: 'Tìm kiếm trên Google',
    titleDraft: 'DỰ THẢO VĂN BẢN LẤY Ý KIẾN ĐÓNG GÓP',
    titleContentMedia: 'THƯ VIỆN ẢNH - VIDEO',
    linkToMediaContent: 'da-phuong-tien/video',
    linkTo: 'gop-y',
  },
  articleDetail: {
    publishedDate: 'Ngày đăng',
    author: 'Tác giả',
    totalView: 'Lượt xem',
    source: 'Nguồn',
    feedbackHelp: 'Phản hồi bài viết',
    sendFeedback: 'Gửi phản hồi',
    feedbackList: 'Danh sách phản hồi',
    searchResult: 'Kết quả tìm kiếm của',
    feedbackFields: {
      fullName: 'Họ tên',
      phone: 'SĐT',
      email: 'Email',
      content: 'Nội dung',
    },
    relatedNews: 'Tin liên quan',
  },
  pdfList: {
    search: 'Tìm kiếm theo số ký hiệu hoặc trích yếu',
    symbolNumber: 'Số ký hiệu',
    issuedDate: 'Ngày ban hành',
    summary: 'Trích yếu',
    download: 'Tải về',
    title: 'Chi tiết văn bản',
    titleOther: 'Văn bản khác',
    attachedFiles: 'File đính kèm',
    effectiveDate: 'Ngày hiệu lực',
    expirationDate: 'Ngày hết hiệu lực',
    signatory: 'Người ký duyệt',
    issuingAgency: 'Cơ quan ban hành',
    textType: 'Loại văn bản',
    effect: 'Hiệu lực',
    selectAgency: 'Tất cả',
    selectDocType: 'Tất cả',
    managerAndFollow: 'Quản lý và theo dõi',
  },
  news: {
    viewAll: 'Xem tất cả',
    noData: 'Không có tin tức nào để hiển thị.',
    updateNew: 'Đang cập nhật bài viết ....',
  },
  media: {
    image: 'Ảnh',
    sound: 'Âm thanh',
    loading: 'Đang tải dữ liệu',
    statusTale: 'Không có',
    tryIt: 'Hãy thử chuyển sang tab khác',
    show: 'Hiển thị',
    up: 'trên',
    results: 'kết quả',
    seeNow: 'Xem ngay',
    loadMore: 'Tải thêm',
    download: 'Tải xuống',
    share: 'Chia sẻ',
    multimedia_gallery: 'Thư viện',
  },
  voterOpinions: {
    title: 'Kiến nghị của cử tri',
    search: 'Tìm kiếm nội dung tóm tắt',
    receivedDate: 'Ngày tiếp nhận',
    source: 'Nguồn tiếp nhận',
    sender: 'Người gửi',
    summary: 'Nội dung tóm tắt ý kiến',
    field: 'Lĩnh vực',
    category: 'Phân loại',
    action: 'Hành động',
    viewDetail: {
      title: 'Xem chi tiết kiến nghị cử tri',
      receivedDate: 'Ngày tiếp nhận',
      source: 'Nguồn tiếp nhận',
      field: 'Lĩnh vực',
      category: 'Phân loại',
      sender: 'Người gửi',
      phone: 'Số điện thoại',
      attachments: 'Văn bản đính kèm',
      email: 'Email',
      content: 'Nội dung',
      delegateReply: 'Nội dung trả lời của',
      secretaryApproved: 'Thư ký đồng ý',
      additionalReply: 'Nội dung trả lời thêm',
    },
  },
  petitions: {
    title: 'Đơn thư',
    search: 'Tìm kiếm nội dung tóm tắt',
    code: 'Mã đơn thư',
    type: 'Loại đơn thư',
    submissionMethod: 'Hình thức gửi',
    receivedDate: 'Ngày tiếp nhận',
    sender: 'Người gửi',
    action: 'Hành động',
    viewDetail: {
      title: 'Xem chi tiết đơn thư',
      code: 'Mã đơn thư',
      name: 'Tên đơn thư',
      type: 'Loại đơn thư',
      senderType: 'Loại người gửi',
      submissionMethod: 'Hình thức gửi',
      address: 'Địa chỉ',
      receivedDate: 'Ngày tiếp nhận',
      sender: 'Người gửi',
      attachments: 'File đính kèm',
      note: 'Ghi chú',
      content: 'Nội dung',
    },
  },
  survey: {
    survey: 'Khảo sát',
    selectRound: 'Chọn đợt khảo sát',
    answerHere: 'Nhập câu trả lời của bạn tại đây',
    essayAnwer: 'Bạn cần nhập nội dung câu trả lời.',
    multipleChoiceAnwer: 'Bạn cần chọn một đáp án.',
    multipleChoicesAnwer: 'Bạn cần chọn ít nhất một đáp án.',
    notifications: 'Thêm thông tin khảo sát thành công!',
    surveyInfomations: 'Thông tin khảo sát',
    submit: 'Gửi khảo sát',
  },
  qa: {
    qa: 'Hỏi đáp',
  },
  contact: {
    contact: 'Liên hệ',
    address: 'Địa chỉ',
    phone: 'Điện thoại',
    workingHours: 'Giờ làm việc',
  },
  rss: {
    title1: 'là viết tắt của cụm',
    title5: 'hay',
    title2: 'Tạm dịch là đồng bộ hóa vô cùng đơn giản. Nói theo cách khác,thì RSS sử dụng để tóm lược những thông tin phong phú.',
    title3:
      ' RSS vào cuối năm 90s đã được phát triển nên bởi Netscape và đã được ứng dụng nhiều trong những weblog, web tin tức. Đây cũng là 1 công nghệ internet vô cùng hữu hiệu, giúp cho người dùng hoàn toàn có thể cập nhật tin tức từ rất nhiều những trang web đa dạng khác nhau mà không cần phải truy cập trực tiếp vào trong trang web đó. Thứ duy nhất mà họ cần sử dụng đó chính là chương trình về đọc tin RSS chuyên biệt',
    title4:
      'Các nguồn kênh tin được cung cấp miễn phí cho các cá nhân và các tổ chức phi lợi nhuận. Chúng tôi yêu cầu bạn cung cấp rõ các thông tin cần thiết khi bạn sử dụng các nguồn kênh tin này từ Cổng thông tin NINH BÌNH. Cổng thông tin NINH BÌNH có quyền yêu cầu bạn ngừng cung cấp và phân tán thông tin dưới dạng này ở bất kỳ thời điểm nào và với bất kỳ lý do nào.',
  },
  draftCmt: {
    titleHeadingPage: 'Lấy ý kiến dự thảo',
    title: 'TIÊU ĐỀ',
    viewAll: 'Xem toàn văn',
    name: 'HỌ TÊN',
    adress: 'ĐỊA CHỈ',
    phone: 'SỐ ĐIỆN THOẠI',
    email: 'EMAIL',
    upload: 'Upload tài liệu',
    titleInput: 'TIÊU ĐỀ',
    content: 'NỘI DUNG',
    cancel: 'Hủy',
    submit: 'Gửi ý kiến',
    viewComments: 'Xem các góp ý',
    sendCmt: 'Gửi góp ý',
    firstPlHInput: 'Nhập',
    titleList: 'CÁC DỰ THẢO VĂN BẢN ĐANG LẤY Ý KIẾN ĐÓNG GÓP',
    notificationsSubmitSuccess: 'Thêm góp ý thành công!',
    notificationsSubmitError: 'Có lỗi xảy ra!',
    noFileDocument: 'Không có tài liệu nào được đính kèm',
    download: 'Tải xuống',
    uploadFile: 'Tải lên tệp',
    required: 'là bắt buộc',
    notValid: 'không hợp lệ',
    accept: 'Chỉ chấp nhận các định dạng: ',
    noSupport: 'Không hỗ trợ xem trước định dạng này.',
  },
};

export const LANG_DEFAULT_EN = {
  home: {
    news: 'news',
    hometitle: 'Home',
    highlightNews: 'Highlight News',
    selectLink: 'Select Link',
    searchArticle: 'Search Article',
    selectLanguage: 'Select Language',
    keywords: 'keywords',
    newDocument: 'NEW TEXT',
    promulgate: 'Promulgate',
    accessStatitics: 'ACCESS STATISTICS',
    accessing: 'Accessing',
    today: 'Today',
    totalVisits: 'total Visits',
    find: 'find',
    searchPlahoder: 'Search',
    viewByDay: 'View news by day',
    checkTable: 'There are no records',
    erorrNotFound: 'Page not found',
    back: 'Back',
    avartarAlt: 'Default avatar',
    viewDetail: 'View detail',
  },
  media: {
    image: 'image',
    sound: 'sound',
    loading: 'Loading',
    statusTale: 'Not available',
    tryIt: 'Try switching to another tab',
    show: 'display',
    up: 'up',
    results: 'results',
    seeNow: 'see now',
    loadMore: 'Load more',
    download: 'Download',
    share: 'Share',
    multimedia_gallery: 'Multimedia Gallery',
  },
  articleDetail: {
    publishedDate: 'Published Date',
    author: 'Author',
    source: 'Source',
    totalView: 'view',
    feedbackHelp: 'Article Feedback',
    sendFeedback: 'Send Feedback',
    feedbackList: 'Feedback List',
    searchResult: 'Search results for',
    feedbackFields: {
      fullName: 'Full Name',
      phone: 'Phone Number',
      email: 'Email',
      content: 'Content',
    },
    relatedNews: 'Related News',
  },
  pdfList: {
    search: 'Search by symbol number or summary',
    symbolNumber: 'Symbol Number',
    issuedDate: 'Issued Date',
    summary: 'Summary',
    download: 'Download',
    title: 'Document System',
    titleOther: 'Other Documents',
    attachedFiles: 'Attached Files',
    effectiveDate: 'Effective Date',
    expirationDate: 'Expiration Date',
    signatory: 'Approver',
    issuingAgency: 'issuing agency',
    textType: 'text type',
    effect: 'effect',
    selectAgency: 'Select the issuing agency',
    selectDocType: 'Select text type',
    managerAndFollow: 'Management and monitoring',
  },
  news: {
    viewAll: 'View All',
    noData: 'There is no news to display.',
    updateNew: 'Updating post ....',
  },
  voterOpinions: {
    title: "Voters' recommendations",
    search: 'Search summary content',
    receivedDate: 'Received Date',
    source: 'Receiving Source',
    sender: 'Sender',
    summary: 'Opinion Summary',
    field: 'Field',
    category: 'Category',
    action: 'Action',
    viewDetail: {
      title: 'See detailed voter opinions',
      receivedDate: 'Received Date',
      source: 'Receiving Source',
      field: 'Field',
      category: 'Category',
      sender: 'Sender',
      phone: 'Phone Number',
      attachments: 'Attached Document',
      email: 'Email',
      content: 'Content',
      delegateReply: "Delegate's Reply",
      secretaryApproved: 'Secretary Approved',
      additionalReply: 'Additional Reply',
    },
  },
  petitions: {
    title: 'Letter',
    search: 'Search summary content',
    code: 'Petition Code',
    type: 'Petition Type',
    submissionMethod: 'Submission Method',
    receivedDate: 'Received Date',
    sender: 'Sender',
    action: 'Action',
    viewDetail: {
      title: 'View application details ',
      code: 'Petition Code',
      name: 'Petition Name',
      type: 'Petition Type',
      senderType: 'Sender Type',
      submissionMethod: 'Submission Method',
      address: 'Address',
      receivedDate: 'Received Date',
      sender: 'Sender',
      attachments: 'Attached File',
      note: 'Note',
      content: 'Content',
    },
  },
  survey: {
    survey: 'Survey',
    selectRound: 'Select Survey Round',
    answerHere: 'Enter your answer here',
    essayAnwer: 'You need to enter the answer content.',
    multipleChoiceAnwer: 'You need to select an answer.',
    multipleChoicesAnwer: 'You need to select at least one answer.',
    notifications: 'Add survey information successfully!',
    surveyInfomations: 'Survey information',
    submit: 'Submit',
  },
  qa: {
    qa: 'Q&A',
  },
  contact: {
    contact: 'Contact',
    address: 'Address',
    phone: 'Phone',
    workingHours: 'Working hours',
  },
};

export const DEFAULT_HOME_PAGE = `<div class="flex flex-col min-h-screen container mx-auto" bis_skin_checked="1">
    <!-- Header -->
    <header data-structure-zone-id="header-zone_ebab326d-1c4e-4336-9e92-883dcb9d3681" class="relative group/structure page-config-component-default flex items-center justify-center">

        <section class="w-full flex flex-col relative group/layout page-config-component-default" data-layout-id="Layout2Hang(1:1)">
            <section data-layout-zone-id="section-row-1_41f531f8-a58e-4d7e-b32b-491fd3068472" class="relative group/layout page-config-component-default">
                
            <div data-module-id="Header" class="relative group/comp mb-2 last:mb-0 page-config-component-default" bis_skin_checked="1">
                    <img class="w-full" src="https://f.bfd.vn/cttlayoutmodules/1763090856216_Screenshot_2025_11_14_102416.png" alt="Header">

                </div></section>
            <section data-layout-zone-id="section-row-2_33a24813-8adc-43b5-bc61-c938550c192d" class="relative group/layout page-config-component-default">
                
            <div data-module-id="HeaderBanner" class="relative group/comp mb-2 last:mb-0 page-config-component-default" bis_skin_checked="1">
                    <img class="w-full" src="https://f.bfd.vn/cttlayoutmodules/1763091091199_Screenshot_2025_11_14_102431.png" alt="Banner Header">
                </div></section>
        </section>
    </header>

    <!-- Navigation -->
    <nav data-structure-zone-id="nav-zone_4f347213-d1f4-4701-8228-51353816f7aa" class="relative group/structure page-config-component-default flex items-center justify-center"><div class="w-full relative group/layout page-config-component-default" data-layout-zone-id="section-box-w-full" data-layout-id="LayoutBoxWfull" bis_skin_checked="1">
                
              <div data-module-id="Menu" class="relative group/comp mb-2 last:mb-0 page-config-component-default" bis_skin_checked="1">
                    <img class="w-full" src="https://f.bfd.vn/cttlayoutmodules/1763091113149_Screenshot_2025_11_14_102440.png" alt="Menu">
                </div></div></nav>

    <!-- Main content -->
    <main class="bg-white">
        <!-- Section group 1 -->
        <section data-structure-zone-id="section-zone-1_6af07048-f1ab-452c-abe6-3e3030a02704" class="relative group/structure page-config-component-default flex items-center justify-center">

            <section class="w-full flex flex-col mb-6 relative group/layout page-config-component-default" data-layout-id="Layout2Hang(1:1(3:4:3))">
                <section data-layout-zone-id="section-1_9c117fab-e1b6-40fd-aa2b-b85479d72376" class="relative group/layout page-config-component-default">
                    
                <div data-module-id="RunnerText" class="relative group/comp mb-2 last:mb-0 page-config-component-default" bis_skin_checked="1">
                        <img class="w-full" src="https://f.bfd.vn/cttlayoutmodules/1763091128439_Screenshot_2025_11_14_102448.png" alt="Runner Text">

                    </div></section>
                <section class="p-2 md:px-4 mt-1">
                    <section class="flex flex-col lg:flex-row gap-4">
                        <section data-layout-zone-id="section-3/10_aae331a1-c378-4a74-9526-1d09bb94756b" class="w-full lg:w-[30%] order-2 lg:order-1 relative group/layout page-config-component-default">
                            
                        <div data-module-id="FeaturedEvent" class="relative group/comp mb-2 last:mb-0 page-config-component-default" bis_skin_checked="1">
                                <img class="w-full" src="https://f.bfd.vn/cttlayoutmodules/1763091159386_Screenshot_2025_11_14_102503.png" alt="Sự kiện nổi bật">

                            </div></section>
                        <section data-layout-zone-id="section-4/10_30b35af9-87ef-4d33-93fb-6fb12d080ec5" class="w-full lg:w-[40%] order-1 lg:order-2 relative group/layout page-config-component-default">
                            
                        <div data-module-id="PostsMain" class="relative group/comp mb-2 last:mb-0 page-config-component-default" bis_skin_checked="1">
                                <img class="w-full" src="https://f.bfd.vn/cttlayoutmodules/1763091175845_Screenshot_2025_11_14_102512.png" alt="Tin chính">

                            </div></section>
                        <section data-layout-zone-id="section-3/10_fec5a281-4fe6-4b56-84ee-760f5d8ce209" class="w-full lg:w-[30%] order-3 lg:order-3 relative group/layout page-config-component-default">
                            
                        
                
              
                
              <div data-module-id="NewText" class="relative group/comp mb-2 last:mb-0 page-config-component-default" bis_skin_checked="1">
                                <img class="w-full" src="https://f.bfd.vn/cttlayoutmodules/1763091193704_Screenshot_2025_11_14_102521.png" alt="Văn bản mới">

                            </div></section>
                    </section>
                </section>
            </section>
        </section>

        <!-- Section group 2 -->
        <section data-structure-zone-id="section-zone-2_a9d76283-a571-43c7-98f1-834558f9907b" class="relative group/structure page-config-component-default flex items-center justify-center">

            <section class="flex flex-col relative group/layout page-config-component-default" data-layout-id="Layout1Hang">
                <section data-layout-zone-id="section-row-1_cb020959-5907-4fec-9404-e1914ac3136f" class="relative group/layout page-config-component-default">
                    
                <div data-module-id="Activity2Columns" class="relative group/comp mb-2 last:mb-0 page-config-component-default" bis_skin_checked="1">
                        <img class="w-full" src="https://f.bfd.vn/cttlayoutmodules/1763091206490_Screenshot_2025_11_14_102537.png" alt="Hoạt động của đoàn Đại Biểu Quốc Hội &amp; Hội Đồng Nhân Dân">

                    </div></section>
            </section>
        </section>

        <!-- Section group 3 -->
        <section class="px-2 md:px-4 mt-3 relative group/structure page-config-component-default flex items-center justify-center pb-5" data-structure-zone-id="section-zone-3_85a551c2-0ed5-48f7-a0d0-3f52ebbd234b">

            <section class="flex flex-col lg:flex-row mt-5 pb-5 relative group/layout page-config-component-default" data-layout-id="Layout2Cot(4:1)">
                <section class="w-full lg:w-3/4 lg:mr-2 relative group/layout page-config-component-default" data-layout-zone-id="section-3/4_a60b5798-859e-4728-98ea-5cd53c6d01ed">
                    
                    
                
                
              
                
              
                
              <div data-module-id="ActivityBanner" class="relative group/comp mb-2 last:mb-0 page-config-component-default" bis_skin_checked="1">
                        <img class="w-full" src="https://f.bfd.vn/cttlayoutmodules/1763091221662_Screenshot_2025_11_14_102556.png" alt="Banner Hoạt động">

                    </div><div data-module-id="ActivityOther" class="relative group/comp mb-2 last:mb-0 page-config-component-default" bis_skin_checked="1">
                        <img class="w-full" src="https://f.bfd.vn/cttlayoutmodules/1763091279547_Screenshot_2025_11_14_102612.png" alt="Hoạt động khác">

                    </div><div data-module-id="EventBanner" class="relative group/comp mb-2 last:mb-0 page-config-component-default" bis_skin_checked="1">
                    <img class="w-full" src="https://f.bfd.vn/cttlayoutmodules/1763091255413_Screenshot_2025_11_14_102655.png" alt="Banner Sự kiện">
                </div><div data-module-id="Event" class="relative group/comp mb-2 last:mb-0 page-config-component-default" bis_skin_checked="1">
                    <img class="w-full" src="https://f.bfd.vn/cttlayoutmodules/1763435270438_Screenshot_2025_11_14_102705.png" alt="Sự kiện">
                </div><div data-module-id="OtherBanner" class="relative group/comp mb-2 last:mb-0 page-config-component-default" bis_skin_checked="1">
                    <img class="w-full" src="https://f.bfd.vn/cttlayoutmodules/1763091266068_Screenshot_2025_11_14_102712.png" alt="Banner khác">
                </div></section>
                <section class="w-full lg:w-1/4 lg:ml-2 relative group/layout page-config-component-default space-y-2" data-layout-zone-id="section-1/4_f09ec823-9e95-4f63-a4a3-c47beac24492">
                    
                
                
              
                
              <div data-module-id="RightBanner" class="relative group/comp mb-2 last:mb-0 page-config-component-default" bis_skin_checked="1">
                        <img class="w-full" src="https://f.bfd.vn/cttlayoutmodules/1763091242418_Screenshot_2025_11_14_102626.png" alt="Banner Right">
                    </div><div data-module-id="LinkPage" class="relative group/comp mb-2 last:mb-0 page-config-component-default" bis_skin_checked="1">
                    <img class="w-full" src="https://f.bfd.vn/cttlayoutmodules/1763111087214_Screenshot_2025_11_14_102636.png" alt="Liên kết trang">
                </div><div data-module-id="AccessInformation" class="relative group/comp mb-2 last:mb-0 page-config-component-default" bis_skin_checked="1">
                    <img class="w-full" src="https://f.bfd.vn/cttlayoutmodules/1763111097683_Screenshot_2025_11_14_102643.png" alt="Thống kê truy cập">
                </div></section>
            </section>
        </section>
    </main>

    <!-- Footer -->
    <footer data-structure-zone-id="footer-zone_432e8c40-966d-4cf0-97e1-4615b6c31cce" class="relative group/structure page-config-component-default flex items-center justify-center"><div class="w-full relative group/layout page-config-component-default" data-layout-zone-id="section-box-w-full" data-layout-id="LayoutBoxWfull" bis_skin_checked="1">
                
              <div data-module-id="Footer" class="relative group/comp mb-2 last:mb-0 page-config-component-default">
                    <img class="w-full" src="https://f.bfd.vn/cttlayoutmodules/1763091320173_Screenshot_2025_11_14_102721.png" alt="Footer">
                </div></div></footer>
</div>`;

export const COLORS = {
  primary: 'text-[#d90000]',
  greenLight: 'text-[#d90000]',
  greenLightHover: 'hover:text-[#d90000]',
};

export const BG_COLORS = {
  primary: 'bg-[#d90000]',
  greenLight: 'bg-[#d90000]',
};

export const BORDER_COLORS = {
  primary: 'border-[#fcd4b1]',
};
